import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./styles/print-taller.css";
import App from "@/App";
import { initializeApp } from "./utils/capacitor";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Inicializar Capacitor cuando la app carga
initializeApp();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrar Service Worker para PWA
// Esto permite que la app funcione offline y sea instalable
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[ATELIER JPM] PWA lista para uso offline');
  },
  onUpdate: (registration) => {
    console.log('[ATELIER JPM] Nueva versión disponible. Cierra todas las pestañas para actualizar.');
    // Opcional: Mostrar notificación al usuario de que hay una actualización
    if (window.confirm('Hay una nueva versión de ATELIER JPM disponible. ¿Desea actualizar ahora?')) {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  }
});
